<template>
    <div class="flex w-full h-full stallions-view justify-content-around">
        <LibyanOrnament vertical class="lib-or mr-5"/>
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">{{ $t('message.stallionList.header') }}</h2>
            </div>
            <StallionTable ref="stallionTable" />
        </div>
    </div>
</template>

<script>
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import StallionTable from "@/views/stallions/components/StallionTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";

export default {
    name: "StallionListView",
    components: {
        CustomButton,
        StallionTable,
        LibyanOrnament,
    },

    data() {
        return {
        };
    },

    methods: {
        reloadTable() {
            this.$refs.stallionTable.reloadTable();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/theme/mytheme/variables";
.stallions-view {
    @media screen and (max-width: 750px) {
        .lib-or {
            display: none;
        }
    }
    @media screen and (max-width: 650px) {
        padding: 0 20px;
    }
}
</style>
